import { render, staticRenderFns } from "./strategicCommunication.vue?vue&type=template&id=0f647eaa&scoped=true&"
import script from "./strategicCommunication.vue?vue&type=script&lang=js&"
export * from "./strategicCommunication.vue?vue&type=script&lang=js&"
import style0 from "./strategicCommunication.vue?vue&type=style&index=0&id=0f647eaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f647eaa",
  null
  
)

export default component.exports